import { GraduationCap, BookOpen, School } from "lucide-react";
import { Card, CardContent } from "../../ui/card";
import { Button } from "../../ui/button";
import OptimizedImage from "../../../utils/landing/OptimizedImage";

export function EducationLevels() {
  const levels = [
    {
      title: "Inicial",
      age: "3-5 años",
      description: "Enfocado en el desarrollo emocional y social a través del juego guiado. Nuestros pequeños aprenden en un ambiente seguro y estimulante que fomenta la curiosidad y sienta las bases para el aprendizaje futuro.",
      image: "/img/landing/inicial.webp",
      icon: <GraduationCap className="h-8 w-8" />,
      features: ["Desarrollo emocional", "Juego guiado", "Ambiente seguro", "Curiosidad natural"]
    },
    {
      title: "Primaria",
      age: "6-11 años",
      description: "Construimos bases sólidas en matemáticas, lectura y ciencias. Nuestro programa de primaria combina la rigurosidad académica con actividades que desarrollan habilidades sociales y valores fundamentales.",
      image: "/img/landing/primaria.webp",
      icon: <BookOpen className="h-8 w-8" />,
      features: ["Matemáticas", "Lectura", "Ciencias", "Valores fundamentales"]
    },
    {
      title: "Secundaria",
      age: "12-16 años",
      description: "Formación académica avanzada y preparación para la universidad. Nuestros estudiantes de secundaria desarrollan pensamiento crítico, habilidades de investigación y la disciplina necesaria para el éxito universitario.",
      image: "/img/landing/secundaria.webp",
      icon: <School className="h-8 w-8" />,
      features: ["Pensamiento crítico", "Investigación", "Preparación universitaria", "Disciplina académica"]
    }
  ];

  return (
    <section id="niveles" className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl font-bold text-primary-custom mb-4">Niveles Educativos</h2>
          <div className="w-24 h-1 bg-primary-custom mx-auto rounded-full mb-6"></div>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Ofrecemos una educación integral y de calidad en todos nuestros niveles, adaptada a las necesidades específicas de cada etapa del desarrollo.
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-8">
          {levels.map((level, index) => (
            <Card
              key={index}
              className="border-primary-custom/20 hover:shadow-xl transition-all duration-300 overflow-hidden group"
            >
              <div className="relative h-48 overflow-hidden">
                <OptimizedImage
                  src={level.image}
                  alt={`Nivel ${level.title}`}
                  fill
                  className="object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4 flex items-center justify-between">
                  <div>
                    <h3 className="text-xl font-bold text-white">{level.title}</h3>
                    <p className="text-white/90 text-sm">{level.age}</p>
                  </div>
                  <div className="bg-secondary-custom p-3 rounded-full text-primary-custom">
                    {level.icon}
                  </div>
                </div>
              </div>
              <CardContent className="pt-6">
                <p className="text-gray-700 text-justify mb-6">
                  {level.description}
                </p>
                <div className="space-y-2">
                  {level.features.map((feature, i) => (
                    <div key={i} className="flex items-center gap-2">
                      <div className="h-1.5 w-1.5 rounded-full bg-primary-custom"></div>
                      <span className="text-sm text-gray-600">{feature}</span>
                    </div>
                  ))}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
